import Api from '@/services/Index';

const register = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/specialstudent/application/start-application', config);
}
const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/login', data);
}

const startApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/start-application', data);
}

const verifyApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/verify-application', data);
}

const updateInformation = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/update-information', data);
}

const updateProgramSelection = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/update-program-selection', data);
}

const courseRegistration = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/update-course-registration', data);
}

const getSectionList = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/section-list', data);
}

const addDocument = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/add-document', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

const summary = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/summary', data);
}

const saveCourseRegistration = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/update-course-registration', data);
}
const uploadDocuments = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/add-document', data,{
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
const showDocuments = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/specialstudent/application/download-document/${id}`,data,{responseType: 'arraybuffer'});
}
const makeApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/specialstudent/application/submit`,data);
}
const pinReminder = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/pin-reminder', data);
}
const deleteRejectedCourse = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/specialstudent/application/remove-course/'+id,data);
}
const previewDocument = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/specialstudent/application/preview-document/${id}`,data);
}



export default {
    register,
    login,
    startApplication,
    verifyApplication,
    updateInformation,
    updateProgramSelection,
    getSectionList,
    addDocument,
    courseRegistration,
    summary,
    saveCourseRegistration,
    uploadDocuments,
    showDocuments,
    makeApplication,
    pinReminder,
    deleteRejectedCourse,
    previewDocument
}
